import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosProductTable from '../components/PosProductTable'
import PosCategoryTable from '../components/PosCategoryTable'
import PosProductImportTable from '../components/PosProductImportTable'
import PosSupplierTable from '../components/PosSupplierTable'
import PosMaterialTable from '../components/PosMaterialTable'

class PosProductPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      Role: this.comp.Role,
      modal: false,
      categoryModal: false,
      isLoading: true,
      tabList: ['Product', 'Category', 'Import', 'Supplier', 'Material'],
      activeTab: '1',
      productList: [],
      categoryList: [],
      storeList: [],
      selectedId: '',
      selectedData: '',
      redirect: false,
      materialList:[]
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  getProductList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            productList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getCategoryList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/category', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            categoryList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            storeList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getMaterialList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios.post(url + ':3002/v1/product/material', data)
    .then(response => {
      const result = response.data;
      if(result.error == true && result.message !== 'Success'){
        alert(result.message)
        return;
      }
      if(this._isMounted){
        this.setState({
          materialList:result.data
        })
      }
    })
    .catch(error => {
      alert(error);
    })
  }

  componentDidMount() {
    this.getCategoryList()
    this.getStoreList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  product = (isEdit, id) => {
    this.props.history.push({
      pathname: '/posproduct/' + id,
      state: { isEdit },
    })
  }

  render() {
    const { activeTab, Role } = this.state

    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <Page className="PosProductPage" title="Product" breadcrumbs={[{ name: 'Product  ', active: true, path: '/posproduct' }]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {(Role === 'Superuser' || Role === 'Admin' || Role === 'Manager' || Role === 'Supervisor' || Role === 'Financial') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString())
                            }}>
                            {item}
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <PosProductTable getCategoryList={this.getCategoryList} data={this.state} {...this.props} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <PosCategoryTable getCategoryList={this.getCategoryList} data={this.state} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <PosProductImportTable getCategoryList={this.getCategoryList} data={this.state} />
                    </TabPane>
                    <TabPane tabId="4" className="py-3">
                      <PosSupplierTable data={this.state} {...this.props} />
                    </TabPane>
                    <TabPane tabId="5" className="py-3">
                      <PosMaterialTable data={this.state} {...this.props} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    )
  }
}
export default PosProductPage
